var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartPrescriptionCard_1;
import { Card, Text, TextFontSize } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services/model-service';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import MyChartPrescriptionCardAPI from './my-chart-prescriptions-card-api';
import './my-chart-prescriptions-card.css';
let MyChartPrescriptionCard = class MyChartPrescriptionCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick, nrSequence, prescriptionType, professional, read, type, when } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        nrSequence,
                        prescriptionType,
                        professional,
                        read,
                        type,
                        when,
                    }
                }));
            }
        };
    }
    static { MyChartPrescriptionCard_1 = this; }
    static { this.propTypes = {
        className: string,
        onClick: eventListener,
        uuid: string,
    }; }
    static { this.defaultProps = {
        width: 12,
    }; }
    render() {
        const { professional, when, read, uuid, className, width = MyChartPrescriptionCard_1.defaultProps.width } = this.props;
        const prescriptionDateFormatted = ModelService.format('date', when, { type: 'shortDate' });
        const notViewedClass = read === 'N' ? 'not-viewed' : '';
        const prescriptionContentClass = `prescriptions-card-content ${notViewedClass}`;
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.NONE, className: `my-chart-prescriptions-card ${className || ''}`, width: width, onClick: () => this.onClick() },
            React.createElement("div", { className: prescriptionContentClass },
                React.createElement("div", { className: 'left-area' },
                    React.createElement("div", { className: 'icon-not-read' }),
                    React.createElement("div", { className: "avatar-area" },
                        React.createElement(Text, { value: `${MessageService.translate('patient.label.executor-profissional')}:` }),
                        React.createElement(Text, { value: professional, size: TextFontSize.SMALL, bold: true, className: "subtitle" }))),
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "date" },
                        React.createElement("span", null,
                            React.createElement(Text, { value: `${MessageService.translate('patient.date')}:` })),
                        React.createElement("span", null,
                            React.createElement(Text, { size: TextFontSize.SMALL, bold: true, value: prescriptionDateFormatted, className: "subtitle" })))))));
    }
};
MyChartPrescriptionCard = MyChartPrescriptionCard_1 = __decorate([
    AwesomeComponent({ api: MyChartPrescriptionCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartPrescriptionCard);
export default MyChartPrescriptionCard;
//# sourceMappingURL=my-chart-prescriptions-card.js.map